import ApiService from "../../commons/services/ApiService";
import CompanyAPI from '../company/CompanyAPI';

const apiService = new ApiService();

const companyAPI = new CompanyAPI();

export default class FeedbackAPI {

    URI_V1 = "/v1/feedback"

    getFeedbacks = async (page = 0, limit = 20, ratingFilter = "ALL") => {
        const companyId = companyAPI.getCompanyManagment().id;
        return await apiService.get(
            `${this.URI_V1}?companyId=${companyId}&page=${page}&limit=${limit}&ratingFilter=${ratingFilter}`
        );
    };

    getFeedbackSummary = async (ratingFilter = "ALL") => {
        const companyId = companyAPI.getCompanyManagment().id;
        return await apiService.get(
            `${this.URI_V1}/summary?companyId=${companyId}&ratingFilter=${ratingFilter}`
        );
    };


}
